import {
    get_tipiDispositivoSicurezza,
    create_tipoDispositivoSicurezza,
    update_tipoDispositivoSicurezza,
    duplica_tipoDispositivoSicurezza,
    delete_tipoDispositivoSicurezza,
} from "@/api/api.tipodispositivosicurezza.js";

const tipiDispositivoSicurezza = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_tipiDispositivoSicurezza().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_tipoDispositivoSicurezza(id, dati) : create_tipoDispositivoSicurezza(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_tipoDispositivoSicurezza(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                duplica_tipoDispositivoSicurezza(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default tipiDispositivoSicurezza;
